import React from "react";
import { Box, Typography, Card, CardMedia } from "@mui/material";
import { motion } from "framer-motion";

const FunctionCard = ({ title, image, onClick }) => (
  <motion.div
    whileHover={{
      scale: 1.05,
      boxShadow: "0 0 30px rgba(255, 215, 0, 0.6)",
    }}
    transition={{ type: "spring", stiffness: 120, damping: 10 }}
  >
    <Card
      onClick={onClick}
      sx={{
        backgroundColor: "#FFF8E1",
        color: "#000",
        borderRadius: "20px",
        whiteSpace: "pre-line",
        overflow: "hidden",
        cursor: "pointer",
        border: "2px solid #FFD700",
        boxShadow: "0 0 15px rgba(255,215,0,0.4)",
        transition: "all 0.3s ease-in-out",
        "&:hover": {
          boxShadow: "0 0 35px rgba(255,215,0,0.8)",
          transform: "translateY(-4px)",
        },
      }}
    >
      {/* 🖼️ Function Image */}
      <CardMedia
        component="img"
        image={image}
        alt={title}
        sx={{
          height: { xs: 220, md: 300 },
          objectFit: "cover",
          filter: "brightness(0.95)",
          transition: "all 0.4s ease",
          "&:hover": {
            filter: "brightness(1.05)",
          },
        }}
      />

      {/* 🪔 Title Section */}
      <Box
        sx={{
          p: 2.5,
          textAlign: "center",
          backgroundColor: "#000",
          borderTop: "2px solid rgba(255,215,0,0.5)",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            color: "#FFD700",
            textShadow: "0 0 10px rgba(255,215,0,0.8), 0 0 20px rgba(255,215,0,0.5)",
            letterSpacing: "0.5px",
            transition: "all 0.3s ease",
            "&:hover": {
              textShadow: "0 0 15px rgba(255,215,0,1), 0 0 30px rgba(255,215,0,0.8)",
            },
          }}
        >
          {title}
        </Typography>
      </Box>
    </Card>
  </motion.div>
);

export default FunctionCard;
